import React from "react";
import styles from "./ManettesFond.module.css";
import {SPRITES} from "./sprites";
import {construire} from "./disposition";
import {resoudre} from "../reglages";
import {REGLAGES} from "./reglages";

/*
 * Fond « Manettes » : des manettes traversent le bandeau, de droite à gauche, à des vitesses et des tailles différentes
 * (les petites sont lointaines, lentes et ternes ; les grandes, proches, rapides et vives).
 * Chaque manette est un des modèles dessinés en pixels (sprites.js) ou une image de la galerie ajoutée par le personnel
 * depuis le tableau de bord (propriété `images`). Disposition tirée avec une graine fixe : identique sur chaque écran.
 */

/**
 * Fond « Manettes » du bandeau. Remplit son parent.
 *
 * @param images    (facultatif) adresses des images de la galerie à mêler aux manettes dessinées ; le fond fonctionne sans
 * @param reglages  (facultatif) valeurs choisies dans le tableau de bord (nombre, vitesse, grille) ; vérifiées ici
 */
export default function ManettesFond({images = [], reglages}) {
    const r = resoudre(REGLAGES, reglages);
    const disposition = React.useMemo(() => construire(images.length, r.nombre), [images.length, r.nombre]);

    return (
        <div className={styles.scene + (r.grille ? "" : " " + styles.sansGrille)} aria-hidden="true">
            {disposition.map((m, i) => {
                const duree = m.duree / r.vitesse;
                const delai = "-" + (m.decalage * duree).toFixed(1) + "s";   // déjà en route à l'ouverture de la page
                return (
                    <div key={i} className={styles.piste}
                         style={{top: m.haut, opacity: m.opacite, animationDuration: duree.toFixed(1) + "s", animationDelay: delai, "--repos": m.repos}}>
                        {m.type === "image"
                            ? <img className={styles.image} src={images[m.indexImage % images.length]} alt="" height={m.hauteur}
                                   style={{animationDelay: delai}}
                                   onError={e => { e.currentTarget.style.visibility = "hidden"; }}/>
                            : <Sprite sprite={SPRITES[m.modele]} m={m} delai={delai}/>}
                    </div>
                );
            })}
        </div>
    );
}

function Sprite({sprite, m, delai}) {
    return (
        <svg className={styles.sprite} width={sprite.largeur * m.echelle} height={sprite.hauteur * m.echelle}
             viewBox={`0 0 ${sprite.largeur} ${sprite.hauteur}`} shapeRendering="crispEdges"
             style={{"--c1": m.couleurs[0], "--c2": m.couleurs[1], "--c3": m.couleurs[2], animationDelay: delai}}>
            {sprite.traces.map(t => <path key={t.caractere} className={styles[t.caractere]} d={t.d}/>)}
        </svg>
    );
}
